export default __webpack_public_path__ + "static/media/cedar.d1dcbac7.webp";